import "core-js/modules/es6.object.assign";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config/index.js';
import { common } from '@/api/api_url';
export default {
  name: 'viewUpgrade',
  data: function data() {
    return {
      upgradeUser: {
        enterprise_name: "",
        enterprise_redit_code: "",
        legan_name: "",
        business_license: "",
        area: [],
        contact_name: "",
        contact_tel: "",
        email: "",
        remark: "",
        authentication: "" // enterprise_code:'',

      }
    };
  },
  computed: {
    //文件访问前缀
    getRoot: function getRoot() {
      var root = config.showImg.pro;

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      return root;
    },
    getUserInfo: function getUserInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  props: {
    TreeData: {},
    setData: {}
  },
  methods: {
    //下载链接
    downloadUrl: function downloadUrl(url) {
      window.open(url);
    },
    init: function init() {
      Object.assign(this.upgradeUser, this.setData);
    }
  }
};